class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.addEventListener('pointerenter', () => {
      clearTimeout(this.closeTimer);
      if (!this.hoverQuery.matches) return;
      this.openTimer = setTimeout(() => {
        this.header.querySelectorAll('header-menu').forEach((menu) => {
          if (menu !== this) menu.close();
        });
        this.mainDetailsToggle.open = true;
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
      }, 120);
    });
    this.addEventListener('pointerleave', () => {
      clearTimeout(this.openTimer);
      if (!this.hoverQuery.matches) return;
      this.closeTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 220);
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.close();
      this.mainDetailsToggle.querySelector('summary').focus();
    });
  }

  disconnectedCallback() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
  }

  close() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

